export const DEVICE_INFO = {
  IS_FIREFOX: navigator.userAgent.toLowerCase().indexOf('firefox') > -1,
};